import React from "react"
import { Grid, Stack } from "@chakra-ui/react"

import { LearnPage, LearnPageAttributesMinimal, LearnPageImageRatio, LearnPageTitle } from "@components/LearnPage"
import { ArticleGridItemProps } from "."

const ArticleGridItemMobile = ({ item, handleTrackingClick }: ArticleGridItemProps) => (
  <LearnPage item={item} handleTrackingClick={handleTrackingClick}>
    <Grid templateColumns="repeat(2, 1fr)" columnGap={2} alignItems="center">
      <LearnPageImageRatio aspectRatioProps={{ ratio: 130 / 141 }} />
      <Stack>
        <LearnPageTitle />
        <LearnPageAttributesMinimal />
      </Stack>
    </Grid>
  </LearnPage>
)

export default React.memo(ArticleGridItemMobile)
